import React from "react";
import IconArrowRight from "./icons/IconGalleryArrowRight";
import { Container } from "./styled/hero-slider-next";
function HeroSliderNext(_a) {
    var onClick = _a.onClick;
    return (React.createElement(Container, { onClick: onClick },
        React.createElement(IconArrowRight, null)));
}
export default HeroSliderNext;
